import { siteInfo } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20subtle%20abstract%20cinema%20texture%20with%20film%20grain%20and%20soft%20curtain-like%20folds%2C%20warm%20cream%20and%20ivory%20tones%2C%20very%20faint%20pattern%2C%20minimalist%20texture%2C%20barely%20visible%20cinematic%20motif&width=1600&height=900&seq=hero-bg-pattern&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-100/80 text-primary-700 rounded-full text-sm font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>{siteInfo.tagline}</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-4">
              {siteInfo.name}
              <span className="block text-primary-600 mt-1">电影大全在线观看平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 max-w-[580px] mx-auto lg:mx-0">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-7">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-secondary-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50 hover:bg-background-200 text-foreground-800 font-semibold text-sm rounded-full border border-background-300 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览专题推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[540px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stunning%20cinematic%20collage%20of%20movie%20posters%20and%20film%20scenes%20featuring%20spaceships%20explosions%20and%20dramatic%20characters%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20rich%20textures%2C%20artistic%20composition%2C%20modern%20movie%20poster%20design%20aesthetic%2C%20dark%20background%20with%20vibrant%20highlights&width=1080&height=810&seq=hero-main-visual&orientation=landscape"
                alt="琪琪影院 - 科幻电影动作电影高清蓝光在线观看"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <span className="px-3 py-1.5 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap backdrop-blur-sm">
                  今日推荐
                </span>
                <span className="text-background-50 text-sm font-medium drop-shadow-lg">
                  星际穿越 · 4K蓝光重制版
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}